import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { ButtonComponent } from '../../../../common/components/button/button.component';

@Component({
  selector: 'app-archive-prompt',
  standalone: true,
  imports: [MatDialogModule, CommonModule, MatButtonModule, ButtonComponent],
  templateUrl: './archive-prompt.component.html',
  styleUrl: './archive-prompt.component.scss'
})
export class ArchivePromptComponent {

  loggedUserId: any;
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<ArchivePromptComponent>,
  ) {
    this.loggedUserId = localStorage.getItem("user_id")
  }

  archivePrompt() {
    const postData = {
      prompt_id: this.data?.prompt_id,
      status: "ARCHIVED",
      curator_user_id: Number(this.loggedUserId)
    }
    this.dialogRef.close(postData);
  }

  cancelArchive() {
    this.dialogRef.close();
  }
}
